export default {
  apiHost: 'https://ywym.znstny.cn'
}



// WEBPACK FOOTER //
// ./src/config/index.js